import * as React from 'react';
import { Create, SimpleForm, TextInput, required, SelectInput } from 'react-admin';

export const ClientCreate = props => (
    <Create title="Create a Client">
        <SimpleForm>    
            <h3>Client's Name</h3>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="clientTag" validate={[required()]}/>
            <SelectInput  source="status" choices={[
                {id: 'active', name:"active"},
                {id: 'inactive', name: "inactive"}
            ]}
            />            
            <h3>Client's Address</h3>
            <TextInput source="streetAddress1" />
            <TextInput source="streetAddress2" />
            <TextInput source="city" />
            <TextInput source="provinceOrState" />
            <TextInput source="country" />
            <TextInput source="postalCode" />
            <TextInput source="website" />

            <h3>Client's Contact</h3>
            <TextInput source="contactFirstName" />
            <TextInput source="contactLastName" />
            <TextInput source="contactEmail" />
            <TextInput source="contactPhone" />           
        </SimpleForm>
    </Create>
);

